import api from "APP_ROOT/api";
import { SUCCESS } from "LIB/submission";
import * as actionTypes from "MODULES/ManagedRepairOrders/actionTypes";
import { List } from "immutable";
import { ACTIVE, CREDIT_HOLD, NO_BIZ } from "MODULES/companies/constants";
import { toastr } from "react-redux-toastr";
import { get } from "lodash";
import { managedRepairOrderLineItems as mroLineItemsPagination } from "./pagination";

function refreshManagedRepairOrderAndLineItems(dispatch, mroId) {
  return api.managedRepairOrders.show(mroId).then(resp => {
    dispatch({ type: actionTypes.SET, managedRepairOrder: resp.data });
    dispatch(mroLineItemsPagination.pageActions.expire());
  });
}

export function addLineItem(values, mroId, afterCreate) {
  return (dispatch, getState) => {
    const id =
      mroId || getState().mroDetail.getIn(["managedRepairOrder", "id"]);

    if (values.displayCoBuyerFields) {
      values.add_co_buyer = true;
    }

    if (values.displayThirdBuyerFields) {
      values.add_third_buyer = true;
    }

    return api.managedRepairOrders.lineItems.create(id, values).then(() => {
      if (afterCreate) {
        afterCreate();
      } else {
        refreshManagedRepairOrderAndLineItems(dispatch, id);
      }
      return SUCCESS;
    });
  };
}

export const bulkUpdateLineItems = data => (dispatch, getState) => {
  const repairOrderID = getState().mroDetail.getIn([
    "managedRepairOrder",
    "id"
  ]);

  return api.managedRepairOrders.lineItems
    .bulkUpdate(repairOrderID, data)
    .then(() => {
      refreshManagedRepairOrderAndLineItems(dispatch, repairOrderID);
      return SUCCESS;
    });
};

export const searchLineItems = pageInfo => (dispatch, getState) => {
  const results = getState()
    .mroDetail.getIn(["managedRepairOrder", "line_items"], List())
    .toJS();
  const { limit, page } = pageInfo.query;
  const data = {
    total_count: results.length,
    results: results.slice(limit * page - limit, page * limit)
  };

  return Promise.resolve({ data });
};

export function show(id) {
  return dispatch =>
    api.managedRepairOrders.show(id).then(resp => {
      dispatch({
        type: actionTypes.SET,
        managedRepairOrder: resp.data
      });
    });
}

export function searchCompanies(filter) {
  return () =>
    api.companies
      .search({
        filter,
        status: [ACTIVE, NO_BIZ, CREDIT_HOLD].join(","),
        sort: "name",
        reverse: false,
        page: 1,
        limit: 20
      })
      .then(resp => Promise.resolve(resp.data.results));
}

export function searchFreightForwarderCompanies(filter) {
  return () =>
    api.companies
      .search({
        filter,
        sort: "name",
        reverse: false,
        page: 1,
        company_type: "freight_forwarder",
        limit: 20
      })
      .then(resp => Promise.resolve(resp.data.results));
}

export function sync() {
  return (dispatch, getState) => {
    const repairOrderID = getState().mroDetail.getIn([
      "managedRepairOrder",
      "id"
    ]);
    return api.managedRepairOrders
      .sync(repairOrderID)
      .then(() => {
        toastr.success("SUCCESS", "Successfully Synced.");
        refreshManagedRepairOrderAndLineItems(dispatch, repairOrderID);

        return SUCCESS;
      })
      .catch(response => {
        toastr.error("ERROR", get(response, "errors", "Sync Failed"));
      });
  };
}

export function update(data) {
  return (dispatch, getState) => {
    const mroID = getState().mroDetail.getIn(["managedRepairOrder", "id"]);

    if (data.contact_id === "Add") {
      data.contact_id = null;
    }

    return api.managedRepairOrders.update(mroID, data).then(resp => {
      dispatch({
        type: actionTypes.SET,
        managedRepairOrder: resp.data
      });
      dispatch(mroLineItemsPagination.pageActions.expire());
      return SUCCESS;
    });
  };
}

export function updateLineItem(lineItemId, values) {
  return (dispatch, getState) => {
    const mroId = getState().mroDetail.getIn(["managedRepairOrder", "id"]);

    if (!values.purchase_for_sale && values.reserve_for_seller_id) {
      values.reserve_for_seller_id = null;
    }

    return api.managedRepairOrders.lineItems
      .update(lineItemId, values)
      .then(() => {
        refreshManagedRepairOrderAndLineItems(dispatch, mroId);
        return SUCCESS;
      });
  };
}

export function returnToCustomer(lineItemId) {
  return (dispatch, getState) =>
    api.managedRepairOrders.lineItems.returnToCustomer(lineItemId).then(() => {
      const mroId = getState().mroDetail.getIn(["managedRepairOrder", "id"]);
      refreshManagedRepairOrderAndLineItems(dispatch, mroId);
      return SUCCESS;
    });
}



// WEBPACK FOOTER //
// ./app/modules/ManagedRepairOrders/actions.js